import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class ImportExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.ImportKeyword;
    }
    visitNode(sb, expr, _options) {
        sb.context.reportUnsupported(expr);
    }
}

//# sourceMappingURL=ImportExpressionCompiler.js.map
